<template>
  <div id="match_detail_news_outer" class="row">
    <div style="min-height: 500px;">
      <latest-news-item-card
        v-for="(item, index) in itemList"
        :item="item"
        :key="'news_detail_' + index"
        target="_blank"
        :href="itemSrc(item)" />
    </div>

    <div style="margin-right: 30px;margin-top: 20px;">
      <bottom-paginator
        v-bind:current="pageIndex"
        v-bind:total="totalPage"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>
  </div>
</template>

<script>
import LatestNewsItemCard from "../news/LatestNewsItemCard";
import BottomPaginator from "../BottomPaginator";

export default {
  name: "MatchDetailNews",
  props: [
    'tagName',
  ],
  components: {
    LatestNewsItemCard,
    BottomPaginator
  },
  computed: {
    matchId() {
      return this.$route.params.id;
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  data() {
    return {
      itemList: [],
      pageIndex: 1,
      size: 10,
      count: 0,
      isLoading: false,
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    paginatorClicked(event) {
      let index = event.index;
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      // let tag = this.tabList[this.tabIndex];
      let tableId = this.matchId;
      let tag = ((this.tagName == undefined || this.tagName == null) ? '' : this.tagName).removeBlanks();
      let params = {
        pageIndex,
        size: this.size,
        tag: tag,
      };
      this.isLoading = true;
      let _this = this;
      this.$store.state.http.ajax.matchDeatilList(params,function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.count = data.count;

          if (newList.length > 0) {
            _this.itemList = newList;
          }
          return;
        }

        _this.$toast('请求失败！');

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0302/0/' + item.id;
    },

    posterImg(item) {
      let imageUrls = item.imageUrls;
      if (imageUrls != null && imageUrls.length > 0) {
        let pic = imageUrls.split('?')[0];
        return pic
      }
      return '';
    }
  }
}
</script>

<style scoped>
  #match_detail_news_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
  }

  @media screen and (min-width: 768px) {
    #match_detail_news_outer {
      padding: 4vh 4vw 6vh 4vw;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/MatchDetailNews.vue